module.exports = __webpack_public_path__ + "static/img/aboutUS.82d2f83d.png";